/** Shared layout constants for CSK story shells. */
export const breakpoints = {
  widthTablet: "700",
  widthDesktop: "1024",
} as const;

export const layout = {
  ledeTextMaxWidth: "37.5rem",
  bodyTextMaxWidth: "37.5rem",
  textWidthPercent: "92%",
  imageMaxWidth: "45rem",
} as const;
